import {
  Button,
  Card,
  Checkbox,
  Col,
  Layout,
  notification,
  Row,
  Space,
  theme,
  TimePicker,
  Typography,
} from "antd";
import React, { useEffect, useRef } from "react";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { renderDay, roles } from "../../../utils/constants";
import {
  addNewTimeInSchedule,
  deleteTimeSchedule,
  getSchedules,
  initInterpreteSlice,
  pushNewSchdedule,
  saveSchedules,
  setPropertiesInterprete,
  updateAddressSchedule,
  updateInterprete,
  updateTimeSchedule,
  updateValuesSchdedule,
} from "../Slices/InterpreteSlice";
import { MdAdd } from "react-icons/md";
import AutoCompleteCustom from "../../../shared/components/AutoCompleteCustom";
import { IoAdd } from "react-icons/io5";
import { ScheduleNotAvailable } from "./ScheduleNotAvailable";
import { userHasLevel } from "../../../engine/AuthRoute";
import dayjs, { generalFormatAntd } from "../../../utils/dayjs";
import dayjsNormal from "dayjs";
import useDeviceDetect from "../../../engine/hooks/useDeviceDetect";
import { AiFillDelete } from "react-icons/ai";
import { HiOutlineMail } from "react-icons/hi";

const { Content, Sider, Header, Footer } = Layout;

export function InterpreteSchedule({ unitId, expanded, onClose }) {
  const { id } = useParams();
  const loc = useLocation();

  const { interprete, loading, schedules } = useSelector(
    state => state.interprete,
  );

  const { isMobile } = useDeviceDetect(1024);

  const { init, clear } = initInterpreteSlice({ id });

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  useEffect(() => {
    if (id !== "new") {
      // dispatch(getBill(id));
      dispatch(getSchedules(id));
    }
  }, []);

  const {
    info: { firstname, lastname, genre, phone },
    email,
    subRoles,
  } = interprete;

  const m2Exposant = (
    <span>
      m<sup>2</sup>
    </span>
  );
  const {
    token: { colorPrimary },
  } = theme.useToken();

  const inputs = [
    {
      parentLabel: "",
      children: [
        {
          label: "Prénom",
          name: "info.firstname",
          value: firstname,
          required: true,
          type: "input",
          col: 24,
        },
        {
          label: "Nom",
          name: "info.lastname",
          value: lastname,
          type: "input",
          required: true,
          col: 24,
        },
        {
          label: "Genre",
          name: "info.genre",
          value: genre,
          required: true,
          type: "select",
          selectContent: [
            { label: "Homme", value: "male" },
            { label: "Femme", value: "female" },
          ],
          col: 24,
        },
        {
          label: "Email",
          name: "email",
          value: email,
          normalize: value => value && value.toLowerCase(),
          addonBefore: <HiOutlineMail />,
          type: "email",
          col: 24,
        },
        {
          label: "Téléphone",
          name: "info.phone",
          value: phone,
          type: "input",
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: id === "new" ? "Créer l'utilisateur" : "Sauvegarder",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
  const formatString = s => {
    return Number(s.replace(/[^0-9.-]+/g, ""));
  };
  const onSubmitForm = async data => {
    await dispatch(setPropertiesInterprete(data));
    dispatch(updateInterprete());
  };

  const newSchedule = () => {
    dispatch(
      pushNewSchdedule({
        id: Math.random(),
        day: "monday",
        type: "schedule",
      }),
    );
  };

  const format = "HH:mm";

  const newHoliday = () => {
    dispatch(
      pushNewSchdedule({
        user: id,
        id: Math.random(),
        type: "holiday",
        dateFrom: dayjs().subtract("1", "d"),
        dateTo: dayjs().add(1, "d"),
      }),
    );
  };

  const disabledDate = current => {
    // Can not select days before today and today
    return current && current < dayjs().endOf("day");
  };

  const schedulesOnly = schedules.filter(t => t.type === "schedule");

  const checkSchedules = () => {
    let days = schedules.filter(e => e.type === "schedule");

    const isValid = days.every(day => {
      // Convert each time range to minutes past midnight
      let ranges = day.times.map(range => ({
        from: range.from.hour * 60 + range.from.minute,
        to: range.to.hour * 60 + range.to.minute,
      }));

      // Sort the ranges by their start time
      ranges.sort((a, b) => a.from - b.from);

      // Check if any range overlaps with the next one
      for (let i = 0; i < ranges.length - 1; i++) {
        if (ranges[i].to > ranges[i + 1].from) {
          return false;
        }
      }

      return true;
    });

    return isValid;
  };

  const saveSchedulesClick = () => {
    if (checkSchedules()) {
      dispatch(saveSchedules());
    } else {
      notification.error({
        message:
          "Certains créneaux horaires se chevauchent. Merci de corriger les heures.",
        duration: 5000,
      });
    }
  };

  return (
    <>
      <div className={"alignHeaderPage"}>
        <Typography.Title level={3} className={""}>
          Disponibilités hebdomadaires
        </Typography.Title>
        <Button type={"primary"} onClick={saveSchedulesClick}>
          Sauvegarder
        </Button>
      </div>

      <br />
      {loading ? (
        <>
          <Card style={{ marginBottom: 5 }} loading={true}></Card>
          <Card style={{ marginBottom: 5 }} loading={true}></Card>
          <Card style={{ marginBottom: 5 }} loading={true}></Card>
          <Card style={{ marginBottom: 5 }} loading={true}></Card>
        </>
      ) : (
        <>
          {/*<CustomForm*/}
          {/*  dataSource={inputs}*/}
          {/*  handleSubmit={data => onSubmitForm(data)}*/}
          {/*  labelCol={24}*/}
          {/*  refForm={formRef}*/}
          {/*  wrapperCol={24}*/}
          {/*  onValuesChange={undefined}*/}
          {/*/>*/}
          {schedulesOnly.map((schedule, scheduleId) => {
            return (
              <Card
                style={{
                  marginBottom: 15,
                }}
                title={renderDay(schedule.day)}
                extra={[
                  <Space direction={"horizontal"}>
                    <label>
                      Disponible{"  "}
                      <Checkbox
                        checked={!schedule.disabled}
                        onChange={e => {
                          dispatch(
                            updateValuesSchdedule({
                              ...schedule,
                              disabled: !schedule.disabled,
                            }),
                          );
                        }}
                      />
                    </label>
                    {"  "}
                    <Button
                      type={"dashed"}
                      size={"small"}
                      icon={<MdAdd size={15} />}
                      onClick={() => {
                        dispatch(addNewTimeInSchedule({ scheduleId }));
                      }}
                    >
                      Ajouter un crénau
                    </Button>
                  </Space>,
                ]}
              >
                <Row
                  gutter={[5, 5]}
                  style={{
                    marginBottom: 5,
                    opacity: schedule.disabled ? 0.5 : 1,
                  }}
                >
                  <Col span={5}>De</Col>
                  <Col span={5}>À</Col>
                  <Col span={11} style={{ textAlign: "left" }}>
                    Lieu de départ alternatif (optionnel)
                  </Col>
                  <Col span={3} style={{ textAlign: "left" }}></Col>
                </Row>
                {schedule.times.map((time, timeId) => {
                  return (
                    <Row
                      gutter={[5, 5]}
                      style={{
                        marginBottom: 5,
                        opacity: schedule.disabled ? 0.5 : 1,
                      }}
                    >
                      <Col span={5}>
                        <TimePicker
                          className={"timePicker"}
                          popupClassName={"timePickerInput"}

                          key={`${time._id ||
                            Math.random()}-${scheduleId}-from`}
                          disabled={schedule.disabled}
                          onChange={(e, r) => {
                            // { scheduleId, timeId, verb, hour, minute }
                            dispatch(
                              updateTimeSchedule({
                                scheduleId,
                                timeId,
                                verb: "from",
                                hour: e.hour(),
                                minute: e.minute(),
                              }),
                            );
                          }}
                          style={{ width: "100%" }}
                          defaultValue={dayjsNormal(
                            `${time.from.hour}:${time.from.minute}`,
                            format,
                          )}
                          format={format}
                        />
                      </Col>
                      <Col span={5}>
                        <TimePicker
                          className={"timePicker"}
                          name={"f"}
                          key={`${time._id || Math.random()}-${scheduleId}-to`}
                          disabled={schedule.disabled}
                          onChange={(e, r) => {
                            // { scheduleId, timeId, verb, hour, minute }
                            dispatch(
                              updateTimeSchedule({
                                scheduleId,
                                timeId,
                                verb: "to",
                                hour: e.hour(),
                                minute: e.minute(),
                              }),
                            );
                          }}
                          style={{ width: "100%" }}
                          defaultValue={dayjsNormal(
                            `${time.to.hour}:${time.to.minute}`,
                            format,
                          )}
                          format={format}
                        />
                      </Col>
                      <Col span={11}>
                        <AutoCompleteCustom
                          disabled={
                            userHasLevel({
                              not: {
                                [roles.interprete]: "r", //
                              },
                            })
                              ? schedule.disabled
                              : true
                          }
                          placeholder={interprete.interpreteData.addressStart}
                          item={{
                            name: `address+${scheduleId}`,
                            value: time.address,
                            disabled: userHasLevel({
                              not: {
                                [roles.interprete]: "r", //
                              },
                            })
                              ? schedule.disabled
                              : true,
                          }}
                          onChange={address => {
                            dispatch(
                              updateAddressSchedule({
                                scheduleId,
                                timeId,
                                address: address,
                              }),
                            );
                          }}
                          onPlaceSelected={(place, address) => {
                            dispatch(
                              updateAddressSchedule({
                                scheduleId,
                                timeId,
                                address: address,
                              }),
                            );
                            // refForm;
                          }}
                        />
                      </Col>
                      <Col span={3}>
                        <Button
                          danger
                          disabled={schedule.disabled}
                          type={"text"}
                          onClick={() => {
                            dispatch(
                              deleteTimeSchedule({
                                scheduleId,
                                timeId,
                              }),
                            );
                          }}
                        >
                          {isMobile ? <AiFillDelete /> : "Supprimer"}
                        </Button>
                      </Col>
                    </Row>
                  );
                })}
              </Card>
            );
          })}
        </>
      )}

      <div className={"alignHeaderPage"}>
        <Typography.Title level={3} className={""}>
          Périodes d'absences
        </Typography.Title>
      </div>
      <Button
        style={{ flex: 1, width: "100%", fontWeight: 600 }}
        size={"large"}
        type={"dashed"}
        danger
        onClick={newHoliday}
      >
        <IoAdd style={{ margin: 0, color: colorPrimary }} size={30} />
        Ajouter une période d'absence
      </Button>

      <br />
      <br />
      {schedules
        .filter(t => t.type === "holiday")
        .map(schedule => {
          return <ScheduleNotAvailable schedule={schedule} />;
        })}
      <div style={{ width: "100%", textAlign: "right" }}>
        <Button type={"primary"} onClick={saveSchedulesClick}>
          Sauvegarder
        </Button>
      </div>
    </>
  );
}
